module.exports = __webpack_public_path__ + "img/fourday_ps_19.89abe68e.jpg";